// src/ProductList.js

export const productDataList = [
  {
    id: 1,
    name: "Product 1",
    description:
      "This is a detailed description of Product 1. It includes all the awesome features and specifications.",
    price: 49.99,
    originalPrice: 69.99,
    imageUrl:
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
    imageUrls: [
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
    ],
    rating: 4.5,
    reviews: [
      { user: "John Doe", comment: "Great product! Highly recommend." },
      { user: "Jane Smith", comment: "Good value for the price." },
    ],
  },
  {
    id: 2,
    name: "Product 2",
    description:
      "This is a detailed description of Product 2. It includes all the awesome features and specifications.",
    price: 49.99,
    originalPrice: 69.99,
    imageUrl:
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
    imageUrls: [
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
    ],
    rating: 4.5,
    reviews: [
      { user: "John Doe", comment: "Great product! Highly recommend." },
      { user: "Jane Smith", comment: "Good value for the price." },
    ],
  },
  {
    id: 3,
    name: "Product 3",
    description:
      "This is a detailed description of Product 3. It includes all the awesome features and specifications.",
    price: 49.99,
    originalPrice: 69.99,
    imageUrl:
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
    imageUrls: [
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
      "https://img.freepik.com/free-photo/elegant-smartphone-composition_23-2149437106.jpg?semt=ais_hybrid",
    ],
    rating: 4.5,
    reviews: [
      { user: "John Doe", comment: "Great product! Highly recommend." },
      { user: "Jane Smith", comment: "Good value for the price." },
    ],
  },
];
